import React, {useEffect, useMemo, useState} from "react";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {formatValueAsDateAndTime} from "../../../../helpers/utils/DateUtils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {useLazyDownloadReportHistoryFilesQuery, useSearchReportHistoryApiQuery} from "../report-history";


function ReportsHistory() {

    const [donwloadReportHistoryApi, donwloadReportHistory] = useLazyDownloadReportHistoryFilesQuery();
    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Report History", url: ""}]
    )
    useEffect(() => {
    }, []);


    useEffect(() => {
        document.title = 'Report History';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: "Export date", accessor: "creationDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.creationDate);
            },
        },
        {
            label: "File Name", accessor: "filename",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter File Name..."}
                                                     name={"fileName"} accessor={"fileName"}/>,
                overrideFilterAccessor: "fileName"
            }],
        },

        {
            label: "Created By", accessor: "createdBy"
        },

        {
            label: "Download",
            accessor: "id",
            canSort: false,
            cell: (props: any) => {
                const handleDownload = () => {
                    donwloadReportHistoryApi(props.row.original.id);
                };

                return (
                    <span
                        className="fa fa-download fa-icon-color ml-2 text-highlight-0"
                        style={{cursor: 'pointer'}}
                        onClick={handleDownload}
                    />
                );
            }
        },


    ];


    return (
        <>
            <div className=" px-4 py-2">
                <div className="flex justify-between mb-2.5">
                    <Breadcrumb crumbs={crumbs}/>
                </div>
                <DataTable
                    columns={columns}
                    actions={{
                        fetchAction: useSearchReportHistoryApiQuery,
                        exportAction: null
                    }}
                    userSettingGroup={"Report History"}
                />
            </div>
        </>
    )
}

export default ReportsHistory;